import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import HubRoundedIcon from '@mui/icons-material/HubRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import { motion, useReducedMotion } from 'framer-motion';
import { RevealHeading } from '../components/motion';
import { colors } from '../theme';

const MotionGrid = motion(Grid);

const items = [
  { icon: <SchoolRoundedIcon />, title: 'Education',
    text: 'Graduated from the University of Bucharest in 2019 with a degree in Computer Science.' },
  { icon: <WorkRoundedIcon />, title: 'Experience',
    text: 'Working as a Java Server Software Engineer for the past 10 years.' },
  { icon: <FavoriteRoundedIcon />, title: 'Passions',
    text: 'I love cars, technology, and sports — driving and weekend bike rides most of all.' },
  { icon: <CodeRoundedIcon />, title: 'Java',
    text: 'Strong command of Java and its ecosystem, with deep proficiency in Java 8.' },
  { icon: <HubRoundedIcon />, title: 'Microservices',
    text: 'Extensive experience building, maintaining, measuring and optimizing microservices.' },
  { icon: <PhoneIphoneRoundedIcon />, title: 'Mobile',
    text: 'Recently building mobile applications with React Native — and loving it.' },
];

const card = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export default function About() {
  const reduce = useReducedMotion();

  return (
    <Box
      id="about"
      sx={{
        backgroundColor: colors.nearBlack,
        color: '#f5f5f7',
        py: { xs: 12, md: 20 },
      }}
    >
      <Container>
        <Box
          component={motion.div}
          initial={reduce ? undefined : { opacity: 0 }}
          whileInView={reduce ? undefined : { opacity: 1 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          sx={{ maxWidth: 900, mx: 'auto', textAlign: 'center', mb: { xs: 8, md: 12 } }}
        >
          <Typography variant="overline" sx={{ color: colors.blue, letterSpacing: '0.24em' }}>
            ABOUT ME
          </Typography>
          <RevealHeading
            variant="h2"
            sx={{ mt: 2, color: '#fff' }}
            segments={[
              { text: 'Ten years of shipping', color: '#fff' },
              { text: 'reliable, high-performance backend systems.', color: '#86868b' },
            ]}
          />
        </Box>

        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          component={motion.div}
          initial={reduce ? undefined : 'hidden'}
          whileInView={reduce ? undefined : 'visible'}
          viewport={{ once: true, amount: 0.15 }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.1 } } }}
        >
          {items.map((it, i) => (
            <MotionGrid item xs={12} sm={6} md={4} key={i} variants={reduce ? undefined : card}>
              <Box
                sx={{
                  height: '100%',
                  p: { xs: 3, md: 4 },
                  borderRadius: 4,
                  backgroundColor: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  transition: 'transform .35s ease, background-color .35s ease, border-color .35s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    backgroundColor: 'rgba(255,255,255,0.07)',
                    borderColor: 'rgba(0,113,227,0.6)',
                  },
                }}
              >
                <Box sx={{ color: colors.blue, mb: 2, '& svg': { fontSize: 30 } }}>{it.icon}</Box>
                <Typography variant="h6" sx={{ color: '#fff', mb: 1 }}>{it.title}</Typography>
                <Typography variant="body1" sx={{ color: '#a1a1a6' }}>{it.text}</Typography>
              </Box>
            </MotionGrid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
